import { render, staticRenderFns } from "./ControleSpecifique.vue?vue&type=template&id=38f610de&scoped=true&"
import script from "./ControleSpecifique.vue?vue&type=script&lang=js&"
export * from "./ControleSpecifique.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f610de",
  null
  
)

export default component.exports
import QPage from 'quasar/src/components/page/QPage.js';
import qInstall from "../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QPage});
